import { didApiUrl } from '@/environment';
import { GetConsentsResponse } from '@/pages/avatar/common/types';
import { authenticatedAxios } from '@/services/auth';

export const deleteAvatar = async (avatarId: string) => {
    const response = await authenticatedAxios.delete(`${didApiUrl}/scenes/avatars/${avatarId}`);
    return response.data;
};

export const deleteTrain = async (trainId: string) => {
    const response = await authenticatedAxios.delete(`${didApiUrl}/clips/avatars/${trainId}`);
    return response.data;
};

export const deletePresenter = async (presenterId: string) => {
    const response = await authenticatedAxios.delete(`${didApiUrl}/clips/presenters/${presenterId}`);
    return response.data;
};

export const getConsents = async (): Promise<GetConsentsResponse> => {
    const response = await authenticatedAxios.get<GetConsentsResponse>(`${didApiUrl}/consents`);
    return response?.data;
};

export const getConsent = async (id: string) => {
    const response = await authenticatedAxios.get(`${didApiUrl}/consents/${id}`);
    return response.data;
};

interface CreateConsentResponse {
    id: string;
    created_at: string;
    text: string;
}
export const createConsent = async (language: string) => {
    const response = await authenticatedAxios.post<CreateConsentResponse>(`${didApiUrl}/consents`, { language });
    return response.data;
};

export const uploadConsent = async (id: string, source_url: string, name: string, signal?: AbortSignal) => {
    const response = await authenticatedAxios.post(
        `${didApiUrl}/consents/${id}`,
        {
            source_url,
            name,
        },
        { signal }
    );
    return response.data;
};

export const deleteConsent = async (id: string) => {
    const response = await authenticatedAxios.delete(`${didApiUrl}/consents/${id}`);
    return response.data;
};
